import React, { useState } from 'react';
import { ECardView } from '../../Enums/ECardView.enum';
// @ts-ignore
import styles from './ECardControls.module.scss';
import AddButton from '../../../../Components/Button/AddButton';
import InputButtonGroup from '../../../../Components/Base/InputButtonGroup/InputButtonGroup';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import ECardViewSwitch from '../ECardViewSwitch/ECardViewSwitch';
import ECardAddFileModal from '../ECardAddFile/ECardAddFileModal';
import ECardAddFolderModal from '../ECardAddFolder/ECardAddFolderModal';
import ECardSharePanel from '../ECardSharePanel/ECardSharePanel';
import { FileToShare } from '../ECard/ECard';
import { ECardType } from '../../Enums/ECardType.enum';
import usePatientConsent from '../../../../Components/PatientProfile/Hooks/usePatientConsent';
import ECardInfoText from '../ECardInfoText/ECardInfoText';

interface Props {
	setView: (view: ECardView) => void;
	view: ECardView;
	setFilter: (filter: string | undefined) => void;
	filter?: string;
	targetPatientId?: string;
	patientId: string;
	reloadFolders: () => void;
	updateFolder: (folderId: string) => void;
	isShareMode: boolean;
	setIsShareMode: (isShareMode: boolean) => void;
	filesToShare: FileToShare[];
	type: ECardType;
	reloadEvent?: (() => void)[];
}

const ECardControls: React.FC<Props> = ({
	setView,
	view,
	setFilter,
	filter,
	patientId,
	reloadFolders,
	updateFolder,
	isShareMode,
	setIsShareMode,
	filesToShare,
	type,
	targetPatientId,
	reloadEvent,
}) => {
	const [isAddFileOpen, setIsAddFileOpen] = useState(false);
	const [isAddFolderOpen, setIsAddFolderOpen] = useState(false);
	const [isFilterInitialized, setIsFilterInitialized] = useState(true);
	const { isConsentProvided } = usePatientConsent(patientId);

	const handleModalClose = (
		needReload: boolean = false,
		folderId: string | null = null,
	) => {
		setIsAddFileOpen(false);
		if (needReload) {
			if (folderId) {
				updateFolder(folderId);
			} else {
				reloadFolders();
			}
			reloadEvent?.map(callback => {
				callback();
			});
		}
	};

	const handleFolderModalClose = (needReload: boolean = false) => {
		setIsAddFolderOpen(false);
		if (needReload) {
			reloadFolders();
		}
	};

	const resetFilter = () => {
		setFilter(undefined);
		setIsFilterInitialized(false);
		setTimeout(() => {
			setIsFilterInitialized(true);
		}, 1);
	};

	const afterShareSuccess = () => {
		setIsShareMode(false);
		setIsShareMode(true);
	};

	return (
		<>
			<div className={styles.wrapper}>
				<div className={styles.start}>
					{(type === ECardType.HEALTH_DOCUMENTATION || isConsentProvided) && (
						<div className={styles.controlButtons}>
							<AddButton
								title={'component.uploadDocumentForm.title'}
								onClick={() => setIsAddFileOpen(true)}
							/>
							<AddButton
								title={'base.newFolder'}
								onClick={() => setIsAddFolderOpen(true)}
							/>
						</div>
					)}
					<div className={styles.filter}>
						{isFilterInitialized && (
							<InputButtonGroup
								placeholder={'base.enterNameOfFile'}
								onSearch={(fulltext: string) => setFilter(fulltext)}
							/>
						)}
						{!!filter && (
							<LinkButton
								onClick={resetFilter}
								title={'base.removeFilter'}
								theme={Theme.RED}
								className={styles.resetButton}
							/>
						)}
					</div>
				</div>

				<div className={styles.end}>
					<ECardViewSwitch view={view} setView={setView} />
				</div>
			</div>
			<ECardInfoText eCardType={type} />
			{isShareMode && (
				<ECardSharePanel
					filesToShare={filesToShare}
					targetPatientId={targetPatientId}
					patientId={patientId}
					onShareSuccess={afterShareSuccess}
					type={type}
				/>
			)}
			<ECardAddFileModal
				opened={isAddFileOpen}
				onClose={handleModalClose}
				patientId={patientId}
				targetPatientId={targetPatientId}
				eCardType={type}
			/>
			<ECardAddFolderModal
				opened={isAddFolderOpen}
				onClose={handleFolderModalClose}
				patientId={patientId}
			/>
		</>
	);
};

export default ECardControls;
